import alphabetical from "./alphabetical";
import popular from "./popular";
import traditional from "./traditional";

export default { traditional, alphabetical, popular };
